<app-region-selector></app-region-selector>
@if (isRedirecting) {
	<loading></loading>
} @else if (!showRegionSelector) {
	<ngx-login
		[isDashboard]="true"
		(onSignUp)="toSignUp()"
		(onForgotPassword)="forgotPassword()"
		(onLogin)="submit($event)"
		(onLoginWithSso)="loginWithSso($event)"
		[disabledButton]="loading$ | async"
		[errorMessage]="formError$ | async">
	</ngx-login>
}
